/* BASAL — visor de fotos de etiqueta y galería real, y paquetes combinados.
   Sin librerías. Sin JavaScript, los enlaces abren la imagen y los paquetes usan el formulario nativo. */
(function () {
  'use strict';

  /* Visor de imágenes ampliables: <a data-bgt-zoom href="imagen-grande"> */
  var dlg, big, cap, opener;
  function buildViewer() {
    dlg = document.createElement('dialog');
    dlg.className = 'bgt-lightbox';
    dlg.setAttribute('aria-label', 'Imagen ampliada');
    dlg.innerHTML = '<div class="bgt-lightbox__bar"><span data-cap></span><button type="button" class="bgt-lightbox__close" aria-label="Cerrar imagen ampliada">×</button></div><img alt="" decoding="async">';
    document.body.appendChild(dlg);
    big = dlg.querySelector('img');
    cap = dlg.querySelector('[data-cap]');
    dlg.querySelector('button').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () {
      big.removeAttribute('src');
      if (opener && opener.focus) opener.focus();
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-bgt-zoom]') : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof HTMLDialogElement !== 'function') return; /* navegador viejo: abre la imagen */
    e.preventDefault();
    if (!dlg) buildViewer();
    opener = a;
    var thumb = a.querySelector('img');
    var alt = thumb ? thumb.getAttribute('alt') || '' : '';
    big.src = a.getAttribute('href');
    big.alt = alt;
    cap.textContent = a.getAttribute('data-caption') || alt;
    dlg.showModal();
  });

  /* Paquetes combinados: agrega varios productos y lleva al carrito. */
  Array.prototype.forEach.call(document.querySelectorAll('form[data-bgt-multi-add]'), function (form) {
    var status = form.querySelector('[data-bgt-status]');
    var btn = form.querySelector('button[type="submit"]');
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      if (status) status.textContent = 'Agregando al carrito…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (res) {
          if (!res.ok) throw new Error('No pudimos agregar el paquete. Intentá de nuevo o escribinos por WhatsApp.');
          window.location.href = form.getAttribute('data-next') || '/cart';
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.setAttribute('aria-busy', 'false'); }
          if (status) { status.textContent = err.message; status.classList.add('is-error'); }
        });
    });
  });
})();
